import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';

export interface ParsedFile {
  cols: string[];
  rows: any[][];
  fileName: string;
}

@Injectable({ providedIn: 'root' })
export class FileParserService {

  parse(file: File): Promise<ParsedFile> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target!.result as ArrayBuffer);
          const wb = XLSX.read(data, { type: 'array' });
          const arr: any[][] = XLSX.utils.sheet_to_json(
            wb.Sheets[wb.SheetNames[0]], { header: 1 }
          );
          if (!arr.length) return reject(new Error('File appears empty.'));
          const cols = (arr[0] || [])
            .map((c: any) => String(c).trim())
            .filter(Boolean);
          const rows = arr.slice(1).filter(r =>
            r.some((c: any) => c !== undefined && c !== '')
          );
          resolve({ cols, rows, fileName: file.name });
        } catch (err: any) {
          reject(err);
        }
      };
      reader.readAsArrayBuffer(file);
    });
  }
}
